import App from "./App.vue";
import { createApp, h } from "vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "@shui/core/bundle";
import "@shui/core/shui/shui-styles.css";
import { createOidcModule } from "@/store/modules/oidc";
import mixins from "./mixins.js";

async function loadConfigs(store) {
  try {
    // console.log("loadConfigs is called.");

    const response = await axios.get(process.env.BASE_URL + "appConfig.json");

    // console.log(response.data);

    store.commit("setAppVersion", response.data.app_version);
    store.commit("setBuildDestination", response.data.build_destination);

    store.commit("setAPI", response.data.api_url);
    store.commit("setMockAPI", response.data.mock_api_url);

    store.commit("setMapAccessToken", response.data.map_access_token);

    store.commit("setOidcConfig", response.data.app_oidc_config);

    const oidcModule = createOidcModule(
      response.data.app_oidc_config,
      response.data.user_group
    );

    store.registerModule("oidcStore", oidcModule);
  } catch (err) {
    console.log(err);
  }
}

loadConfigs(store).then(() => {
  const app = createApp({
    render: () => h(App),
  });

  app.use(router);
  app.use(store);

  app.mixin(mixins);

  app.mount("#app");
});
